import React from "react";
import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import InnerBanner from "../components/inner_banner/InnerBanner";
import Sidebar from "../components/sidebar/Sidebar";
import "./Pages.css";

const Placement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menu = [
    { name: "Placement Cell", path: "placement-cell" },
    { name: "Placement Team", path: "placement-team" },
    { name: "Placement Training", path: "placement-training" },
    { name: "MOU", path: "mou" },
    { name: "Top Recruiters", path: "top-recruiters" },
    { name: "Placement Statistics", path: "placement-statistics" },
    { name: "Sample CV", path: "sample-cv" },
  ];

  const activeItem =
    menu.find((m) => location.pathname.includes(m.path))?.name || "Placement";

  // Mapping for title + background based on route
  const bannerDataMap = {
    "placement-cell": {
      title: "Placement Cell",
      bgImage: "/assets/images/inner_bnr/Placement.jpg",
    },
    "placement-team": {
      title: "Placement Team",
      bgImage: "/assets/images/inner_bnr/pexels.jpg",
    },
    "placement-training": {
      title: "Placement Training",
      bgImage: "/assets/images/inner_bnr/pexels-khunkorn2.jpg",
    },
    mou: {
      title: "MOU",
      bgImage: "/assets/images/inner_bnr/MOU.jpg",
    },
    "top-recruiters": {
      title: "Top Recruiters",
      bgImage: "/assets/images/inner_bnr/pexels-lichtblick.jpg",
    },
    "placement-statistics": {
      title: "Placement Statistics",
      bgImage: "/assets/images/inner_bnr/DSC_2059.jpg",
    },
    "sample-cv": {
      title: "Sample CV",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },
  };

  //  Reusable function to fetch matching banner data
  const getBannerData = () => {
    const matchedKey = Object.keys(bannerDataMap).find((key) =>
      location.pathname.includes(key),
    );

    // If no match found → default to About MANET
    return (
      bannerDataMap[matchedKey] || {
        title: "Placement",
        bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
      }
    );
  };

  const { title, bgImage } = getBannerData();

  const subtitle = "Sailing Towards Excellence & a Brighter Future with MANET";

  console.log("welcome");
  return (
    <>
      <InnerBanner bgImage={bgImage} title={title} subtitle={subtitle} />

      <div className="page-layout">
        <Sidebar menuItems={menu} />

        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Placement;
